import Icon from 'veui/components/Icon'
import { IconClockwise } from 'dls-icons-vue'

Icon.register('clockwise', IconClockwise)
